module.exports = __webpack_public_path__ + "b42206f0043daa0e86deefc358255a4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/fitness/apple-touch-icon.png
// module id = 1844
// module chunks = 1